import { InputNumber } from '@firesoon/antd';
import { InputNumberProps } from '@firesoon/antd/lib/input-number';
import { useMemoizedFn } from 'ahooks';
import classnames from 'classnames';
import React, { useState } from 'react';
import { getNumber, removeExtraDecimalPoints } from './config';
import './index.less';

export default (props: InputNumberProps) => {
  const { value: propsValue, className, min, max, formatter, parser, onChange, onBlur, precision, ...rest } = props;
  const [midValue, setMidValue] = useState<number | undefined>(props?.defaultValue);

  // 兼容受控与非受控
  const value = (() => {
    if ('value' in props) {
      return propsValue;
    }
    return midValue;
  })();

  const setValue = useMemoizedFn((v?: number) => {
    if ('onChange' in props) {
      onChange?.(v);
    }
    return setMidValue(v);
  });

  const onFormatter = useMemoizedFn((v?: string | number) => {
    // 显示小数点只能输入一位
    const _value = removeExtraDecimalPoints(v);
    if (formatter) {
      return formatter(_value);
    }
    return _value || '';
  });

  const onParser = (v?: string) => {
    // 格式化
    const _value = removeExtraDecimalPoints(v);
    if (parser) {
      return parser(_value);
    }
    return _value || '';
  };

  const handleBlur = (e: any) => {
    onBlur?.(e);
    // 如果没有数据就不做处理
    if (!value) return;

    const _value = (() => {
      // 超出最大值取最大值
      if ((max || max === 0) && Number(value) > max) {
        return Number(max);
      }

      // 超出最小值取最小值
      if ((min || min === 0) && Number(value) < min) {
        return Number(min);
      }

      // 存在精度则使用精度做处理
      if (precision || precision === 0) {
        return value?.toFixed(precision);
      }

      return value;
    })();

    setValue(Number(_value));
  };

  const handleChange = (v?: any) => {
    // 如果类型为number或者不存在v说明没有中英文字符 不需要做处理
    if (!v || typeof v === 'number') {
      return setValue(v);
    }
    setValue(getNumber(removeExtraDecimalPoints(v)!));
  };

  return (
    <InputNumber
      placeholder="输入数值"
      className={classnames('fs-input-number', className)}
      min={min}
      max={max}
      value={value}
      precision={precision}
      formatter={onFormatter}
      parser={onParser}
      onChange={handleChange}
      onBlur={handleBlur}
      {...rest}
    />
  );
};
